import React, { useState } from "react";
import FollowingCarousel from "../FollowingCarousel";
import "./FollowingCat.css";
import FollowingContent from "./FollowingContent";
import FollowingSuggested from "./FollowingSuggested";
import FollowingSuggestedMap from "./FollowingSuggestedMap";

import { FollowContext } from "../../../../../../CustomHelper/Helper";
import AllFollowUnFollowStar from "../../Category/Content/AllFollowUnFollowStar";

const FollowingMap = () => {
  const [checkRealTime, setCheckRealTime] = useState(false);



  const [followingCat, setStarCategory] = useState([]);
  const [suggFollowingCat, setSuggStarCategory] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [allFollowingCat, setFollowingCategory] = useState([]);
  const [catId, setCatId] = useState();


  const moveData = (data) => {
    setCheckRealTime(data);
  };

  return (
    <>
      {/* <FollowContext.Provider
        value={{
          followingCat,
          setStarCategory,
          suggFollowingCat,
          setSuggStarCategory,
          allCategory,
          setAllCategory,
          catId,
          setCatId,
          allFollowingCat,
          setFollowingCategory,
        }}
      > */}
        <div className="bg-dark my-2 mt-3 SuggestedCat">
          {/* <FollowingCarousel
            checkRealTime={checkRealTime}
            onMoveData={moveData}
          /> */}
        </div>


        <AllFollowUnFollowStar />

      {/* </FollowContext.Provider> */}
    </>
  );
};

export default FollowingMap;
